import { INGTimePickerProps } from "../../library/NGFieldExtensions";
import { setupHandlers, setupLocalState } from "../../library/dataService";
import { signal, useSignal } from "@preact/signals-react";
import { markPickerClose, markPickerOpen } from "../NGDatePicker/pickerGuard";
import { TimePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { getTypename } from "../../library/metadataUtils";
import { getTestId, partitionMUIClasses } from "../../library/utils";
import { publishUserAction } from "../../library/analytics";

export default function NGTimePicker({ config, context }: INGTimePickerProps) {
  const local = setupLocalState(
    config,
    {
      Disabled: useSignal(config.Disabled ?? false),
      Style: useSignal(config.Style ?? {}),
      Classes: useSignal(config.Classes ?? []),
      Value: useSignal(config.Value ?? null),
    },
    context
  );

  const handlers = setupHandlers(config, context);

  // Check localization in total

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TimePicker
        data-testid={getTestId(config)}
        data-type={getTypename(config)}
        value={local.Value.value ? dayjs(local.Value.value, "HH:mm:ss") : null}
        label={config.Label}
        slotProps={{
          field: {
            clearable: true,
            onClear: () => (local.Value.value = null),
            "data-testid": getTestId(config),
            "data-type": config.__typename,
          },
        }}
        {...handlers}
        onOpen={() => markPickerOpen()}
        onClose={() => markPickerClose()}
        onAccept={() => markPickerClose()}
        disabled={local.Disabled.value}
        onChange={(newValue) => {
          local.Value.value = newValue ? dayjs(newValue).format("HH:mm:ss") : null;

          const [_, classes] = partitionMUIClasses(local.Classes.value);
          const action = publishUserAction(config, context, "time_picker_change", null, {
            ElementText: config.Label,
            Value: local.Value.value,
            EventCategory: "engagement",
            ElementClass: classes.join(" "),
          });

          if (handlers["onChange"]) handlers["onChange"](newValue, null, action);
        }}
      />
    </LocalizationProvider>
  );
}
